//import React from 'react';

import React, {useEffect} from 'react';  
//import { Col } from 'react-bootstrap';
//import { Link } from 'react-router-dom';
 import { makeEmptyCart } from '../../redux/slices/CartSlice';
 import { useDispatch,useSelector } from 'react-redux';
 //import paths from '../../routes/paths'
// import { ThunkDispatch } from '@reduxjs/toolkit';

const  Success = () => {
 //  const {makeEmptyCart} = useSelector((state:any) => state.cart)
   const dispatch = useDispatch();
   const queryString = window.location.search;
   const {loggedInUser} = useSelector((state:any) => state.auth)

   // Create a new URLSearchParams object
   const urlParams = new URLSearchParams(queryString);

   // Get the values of 'token' and 'email'
   const msg = urlParams.get('msg');
   const email = urlParams.get('email');
   const name = urlParams.get('name');
   const customerType = urlParams.get('type');

   const getDate = () => {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${date}${month}${year}`;
  }

  useEffect(() =>{
    dispatch(makeEmptyCart());
  },[dispatch])
  return (
    <div className="page-content bg-light">
      <div className="content-inner-1">
        <div className="container">
          <div className='account-wrapper'> 
            <div className='account-card'> 
              <div className="m-b30">
                <p>Hello <strong className="text-black">{name}</strong> </p>
                <p>{msg}</p>
                {/* {loggedInUser !== null && (
                  <>
                    <p>Please goto  <strong className="text-black">                            
                      <Link to={paths.home} className=" text-900 text-underline ">My Orders</Link> 
                    </strong> to access your orders. </p>
                  </>
                )} */}
                {loggedInUser === null && (
                  <>
                    <p>Please login with below credentials to access your account. </p>
                    <div className='m-b20'>
                        <div><strong className="text-black ">Email: </strong>{email}</div>
                        {customerType === "New" &&  <div><strong className="text-black">Password: </strong>{getDate()}</div>}
                       
                    </div>
                    <p>From your account dashboard you can view your <span className="text-underline">recent orders</span>, manage your <span className="text-underline">Wishlist</span>, and <span className="text-underline">edit your password and account details</span>.</p>
                  
                  </>
                )}
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Success;

 
